import { createContext, useContext } from "react";
import { MapCanvasStagePositionState } from "./MapCanvasContext.types";

export const MapCanvasStagePositionContext =
  createContext<MapCanvasStagePositionState | null>(null);

export const useMapCanvasStagePosition = () => {
  const context = useContext(MapCanvasStagePositionContext);
  if (!context) {
    throw new Error(
      "useMapCanvasStagePosition must be used within a MapCanvasProvider"
    );
  }
  return context;
};
